import { getRef } from "@/lib/referral";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { AuthShell, FormError } from "./AuthShell";

export default function SignUp() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) return setError("Your password needs at least 8 characters.");
    setBusy(true);
    try {
      const data = await register({ ...form, ref_code: getRef()?.code });
      navigate("/check-email", { replace: true, state: { emailSent: data.email_sent, emailStatus: data.email_status, emailError: data.email_error } });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Create an account" title="Set up your EVR account" subtitle="You'll confirm your email, then tell us if you're a homeowner or agent and add your first property."
      footer={<>Already have an account? <Link to="/signin" data-testid="signup-to-signin-link" className="font-medium text-navy underline underline-offset-4">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="signup-form">
        <div className="space-y-2">
          <Label htmlFor="name">Your name</Label>
          <Input id="name" data-testid="signup-name-input" value={form.name} onChange={set("name")} required autoComplete="name" className="h-11" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" data-testid="signup-email-input" value={form.email} onChange={set("email")} required autoComplete="email" className="h-11" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" data-testid="signup-password-input" value={form.password} onChange={set("password")} required autoComplete="new-password" className="h-11" />
          <p className="text-xs text-slate-500">At least 8 characters.</p>
        </div>
        <FormError message={error} testId="signup-error" />
        <Button type="submit" disabled={busy} data-testid="signup-submit-button" className="h-11 w-full bg-navy hover:bg-navy-2">
          {busy ? "Creating your account..." : "Create account"}
        </Button>
      </form>
    </AuthShell>
  );
}
